class ProductVariantDropdown extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
      if (document.querySelectorAll('.template-product').length && !this.closest('#content_quickview')) {
        this.updateURL();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    // Always run image filter (doesn't require featured_media on the variant object)
    this.filterMediaByVariant();
    // Scroll to featured media if available
    if (this.currentVariant.featured_media) {
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.productId}-${this.currentVariant.featured_media.id}"]`
      );
      if (newMedia) {
        const parent = newMedia.parentElement;
        const itemact = document.querySelectorAll('.proFeaturedImage .item');
        for (var i = 0; i < itemact.length; i++) itemact[i].classList.remove('act');
        newMedia.classList.add('act');
        window.setTimeout(() => { parent.scroll(0, 0) });
      }
    }
  }

  filterMediaByVariant() {
    if (!window.$) return;

    const dataEl = document.getElementById('nov-product-media-data');
    if (!dataEl) return;

    let pageData;
    try { pageData = JSON.parse(dataEl.textContent); } catch(e) { return; }

    const allMediaIds = pageData.media.map(m => m.id);
    const variants   = pageData.variants;

    // Look up featuredImageId from embedded JSON by variant ID
    const variantEntry      = variants.find(v => v.id === this.currentVariant.id);
    const currentFeaturedId = variantEntry ? variantEntry.featuredImageId : null;

    // Determine visible position range
    // Determine visible position range (-1 means show placeholder only)
    let currentPos = -1;
    let endPos     = -1;

    if (currentFeaturedId) {
      const seenPositions = new Set();
      const variantStartPositions = variants
        .filter(v => v.featuredImageId !== null)
        .map(v => ({ pos: allMediaIds.indexOf(v.featuredImageId) }))
        .filter(v => v.pos !== -1)
        .sort((a, b) => a.pos - b.pos)
        .filter(v => {
          if (seenPositions.has(v.pos)) return false;
          seenPositions.add(v.pos);
          return true;
        });

      const cPos = allMediaIds.indexOf(currentFeaturedId);
      if (cPos !== -1) {
        currentPos  = cPos;
        const cIdx  = variantStartPositions.findIndex(v => v.pos === cPos);
        const nxt   = variantStartPositions[cIdx + 1];
        endPos      = nxt ? nxt.pos : allMediaIds.length;
      }
    }

    const $FeaturedImage = $('.FeaturedImage_slick');

    // Destroy featured Slick, filter items, re-init with visible only
    if ($FeaturedImage.hasClass('slick-initialized')) $FeaturedImage.slick('destroy');

    $FeaturedImage.find('.item').not('.slick-cloned').each(function() {
      if ($(this).hasClass('placeholder-item')) {
        $(this).toggle(!currentFeaturedId).removeClass('act');
      } else {
        const pos = parseInt($(this).data('position'), 10);
        $(this).toggle(pos >= currentPos && pos < endPos).removeClass('act');
      }
    });
    $FeaturedImage.find('.item:visible').first().addClass('act');

    const visibleCount = $FeaturedImage.find('.item:visible').length;

    window.setTimeout(() => {
      if (!$FeaturedImage.length) return;
      const dots      = visibleCount > 1 ? $FeaturedImage.data('dots') : false;
      const nav       = visibleCount > 1 ? $FeaturedImage.data('nav') : false;
      const draggable = visibleCount > 1 ? $FeaturedImage.data('draggable') : false;
      const isInfinite = visibleCount > 1; // disable infinite if only 1 item
      
      const items     = Math.min($FeaturedImage.data('items')    || 1, visibleCount);
      const items_lg  = Math.min($FeaturedImage.data('items_lg') || 1, visibleCount);
      const items_md  = Math.min($FeaturedImage.data('items_md') || 1, visibleCount);
      const items_sm  = Math.min($FeaturedImage.data('items_sm') || 1, visibleCount);
      const items_xs  = Math.min($FeaturedImage.data('items_xs') || 1, visibleCount);

      $FeaturedImage.slick({
        slide: '.item:visible',
        nextArrow: '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
        prevArrow: '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
        slidesToShow: items,
        slidesToScroll: 1,
        dots: dots,
        arrows: nav,
        adaptiveHeight: true,
        infinite: isInfinite,
        speed: 400,
        cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
        draggable: draggable,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: items_lg, slidesToScroll: 1 } },
          { breakpoint: 992,  settings: { slidesToShow: items_md, slidesToScroll: 1 } },
          { breakpoint: 768,  settings: { slidesToShow: items_sm, slidesToScroll: 1, dots: false } },
          { breakpoint: 576,  settings: { slidesToShow: items_xs, slidesToScroll: 1 } }
        ]
      });
    }, 100);

    // Filter custom thumbnail strip (static HTML from Liquid — just show/hide)
    const $track = $('#customThumbNative .cts-track');
    if (!$track.length) return;

    $track.find('.thumbItem').each(function() {
      if ($(this).hasClass('placeholder-item')) {
        $(this).toggle(!currentFeaturedId);
      } else {
        const pos = parseInt($(this).data('position'), 10);
        $(this).toggle(pos >= currentPos && pos < endPos);
      }
    });

    // Mark first visible thumb active, scroll to top
    $track.find('.thumbItem:visible').removeClass('active').first().addClass('active');
    const trackEl = $track[0];
    if (trackEl) {
      trackEl.scrollTo({ top: 0, behavior: 'smooth' });
      const $prev = $('#customThumbNative .cts-prev');
      const $next = $('#customThumbNative .cts-next');
      $prev.toggleClass('cts-btn--hidden', true); // at top after reset
      $next.toggleClass('cts-btn--hidden', trackEl.scrollHeight <= trackEl.clientHeight);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.productUrl}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('fieldset')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId;
    fetch(`${this.dataset.productUrl}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPrice-${this.dataset.productId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const additionalIds = [
          `ProductTitle-${this.dataset.productId}`,
          `ProductShortDescription-${this.dataset.productId}`,
          `ProductSpecification-${this.dataset.productId}`,
          `ProductDescription-${this.dataset.productId}`
        ];
        additionalIds.forEach((descId) => {
          const destDesc = document.getElementById(descId);
          const srcDesc = html.getElementById(descId);
          if (srcDesc && destDesc) destDesc.innerHTML = srcDesc.innerHTML;
        });


        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
        const variant_id = document.getElementById("variant_id").getAttribute('value');
        const sku = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-sku');
        const variantSku = document.getElementById('variantSku');
        if (typeof variantSku !== 'undefined' && variantSku) {
          variantSku.innerHTML = sku;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const variant_id = document.getElementById("variant_id").getAttribute('value');
      const inventoryPolicy = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_policy');
      const inventoryManagement = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_management');
      if(inventoryPolicy == 'continue' && inventoryManagement == 'shopify' ) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.productId}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('product-variant-dropdown', ProductVariantDropdown);

class ProductVariantSwatch extends ProductVariantDropdown {
  constructor() {
    super();
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('product-variant-swatch', ProductVariantSwatch);

class ProductVariantSelectsStick extends ProductVariantDropdown {
  constructor() {
    super();
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-sticky-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  renderProductInfo() {
    fetch(`${this.dataset.productUrl}?variant=${this.currentVariant.id}&section_id=${this.dataset.productId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `ProductPriceStick-${this.dataset.productId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (source && destination) destination.innerHTML = source.innerHTML;
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.notify_me);
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-sticky-${this.dataset.productId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > #AddToCartText');
    const addButtonParent = productForm.querySelector('.product-form__item--submit');
    const addButton2 = productForm.querySelector('.product-form__item--checkout');
    if (!addButton) return;

    if (disable) {
      if (text) addButtonParent.setAttribute('data-toggle', 'modal');
      if (text) addButtonParent.setAttribute('data-target', '#Form_newletter');
      if (text) addButtonParent.classList.add('soldout');
      if (text) addButtonText.textContent = text;
      if (!addButton2) return;
      addButton2.setAttribute('disabled', true);
    } else {
      const variant_id = document.getElementById("variant_id").getAttribute('value');
      const inventoryPolicy = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_policy');
      const inventoryManagement = document.getElementById("productSelect").querySelector('[value="'+variant_id+'"]').getAttribute('data-inventory_management');
      if(inventoryPolicy == 'continue' && inventoryManagement == 'shopify' ) {
        addButtonText.textContent = window.variantStrings.preorder;
      } else {
        addButtonText.textContent = window.variantStrings.addTobag;
      }
      addButtonParent.classList.remove('soldout');
      addButtonParent.removeAttribute('data-toggle');
      addButtonParent.removeAttribute('data-target');
      if (!addButton2) return;
      addButton2.removeAttribute('disabled');
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const addButton = document.getElementById(`product-form-sticky-${this.dataset.productId}`)?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('#AddToCartText');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
}

customElements.define('product-variant-selects-stick', ProductVariantSelectsStick);

/**
 * On page load: filter images to match the initially selected variant
 * and wire up custom thumbnail events (click + featured sync).
 */
document.addEventListener('DOMContentLoaded', () => {
  // Wait for Slick (featured image) to initialise before filtering
  window.setTimeout(initVariantFilter, 500);
});

function initVariantFilter() {
  if (!window.$) return;

  const variantEl =
    document.querySelector('product-variant-swatch') ||
    document.querySelector('product-variant-dropdown');

  if (variantEl) {
    variantEl.updateOptions  && variantEl.updateOptions();
    variantEl.updateMasterId && variantEl.updateMasterId();
    if (variantEl.currentVariant) {
      variantEl.filterMediaByVariant && variantEl.filterMediaByVariant();
    }
  }

  // ── Wire custom thumbnail events (once) ─────────────────────────────────
  const $track       = $('#customThumbNative .cts-track');
  const $featuredImg = $('.FeaturedImage_slick');
  const $prev        = $('#customThumbNative .cts-prev');
  const $next        = $('#customThumbNative .cts-next');

  if (!$track.length) return;

  // Scroll arrows
  const SCROLL_AMT = 110;
  $prev.on('click.cts', () => $track[0].scrollBy({ top: -SCROLL_AMT, behavior: 'smooth' }));
  $next.on('click.cts', () => $track[0].scrollBy({ top:  SCROLL_AMT, behavior: 'smooth' }));

  // Update arrow visibility on scroll
  function updateArrows() {
    const el = $track[0];
    $prev.toggleClass('cts-btn--hidden', el.scrollTop <= 0);
    $next.toggleClass('cts-btn--hidden', el.scrollTop + el.clientHeight >= el.scrollHeight - 2);
  }
  $track.on('scroll.cts', updateArrows);
  updateArrows();

  // Thumbnail click → go to featured slide
  $track.on('click.cts', '.thumbItem', function(e) {
    e.preventDefault();
    const $visibleThumbs = $track.find('.thumbItem:visible');
    const idx = $visibleThumbs.index(this);
    $visibleThumbs.removeClass('active');
    $(this).addClass('active');
    if ($featuredImg.hasClass('slick-initialized')) {
      $featuredImg.slick('slickGoTo', idx);
    }
  });

  // Featured slide change → highlight active thumb + scroll into view
  $featuredImg.off('afterChange.cts').on('afterChange.cts', function(e, slick, currentSlide) {
    const $visibleThumbs = $track.find('.thumbItem:visible');
    $visibleThumbs.removeClass('active');
    const $active = $visibleThumbs.eq(currentSlide).addClass('active');
    if ($active.length) {
      const el         = $track[0];
      const thumbTop   = $active[0].offsetTop;
      const thumbH     = $active.outerHeight(true);
      el.scrollTo({ top: thumbTop - el.clientHeight / 2 + thumbH / 2, behavior: 'smooth' });
    }
  });
}

